import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { SupabaseSignupPage } from '../components/SupabaseSignupPage';
import { ROUTES } from '../routes';

const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Get pre-filled email from URL parameters (from checkout success)
  const prefilledEmail = searchParams.get('email') || '';

  const handleSuccess = () => {
    // Redirect to the page they were trying to access, or home
    const from = location.state?.from?.pathname || ROUTES.HOME;
    navigate(from, { replace: true });
  };

  const handleSwitchToLogin = () => {
    navigate(ROUTES.LOGIN, { state: location.state });
  };

  return (
    <SupabaseSignupPage
      prefilledEmail={prefilledEmail}
      onSuccess={handleSuccess}
      onSwitchToLogin={handleSwitchToLogin}
    />
  );
};

export default SignupPage;
